import request from '@/utils/request';
export function getFormConfigInfo(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/merchant/form/temp/info',
    method: 'GET',
    params: data
  });
}

/**
 * 通过名称查询详情
 * @param pram
 */
export function formTempNameInfoApi(params) {
  return request({
    url: "/admin/merchant/form/temp/name/info",
    method: 'get',
    params: params
  });
}

/**
 * @description 验证行为验证码
 */
export function knowUserSmsCaptchaApi(data) {
  return request({
    url: '/publicly/safety/check',
    method: 'post',
    data: data
  });
}

/**
 * @description 获取行为验证码
 */
export function knowUserCaptchaApi(data) {
  return request({
    url: '/publicly/safety/get',
    method: 'post',
    data: data
  });
}

/**
 * 系统通知列表
 * @param pram
 */
export function notificationListApi(pram) {
  var data = {
    sendType: pram.sendType
    //发送类型（1：通知会员，2：通知平台）
  };
  return request({
    url: '/admin/platform/notification/list',
    method: 'GET',
    params: data
  });
}

/**
 * 小程序订阅模板开关
 * @param id
 */
export function notificationRoutine(id) {
  return request({
    url: '/admin/platform/notification/routine/switch/' + id,
    method: 'post'
  });
}

/**
 * 公众号模板开关
 * @param id
 */
export function notificationWechat(id) {
  return request({
    url: '/admin/platform/notification/wechat/switch/' + id,
    method: 'post'
  });
}

/**
 * 发送短信开关
 * @param id
 */
export function notificationSms(id) {
  return request({
    url: '/admin/platform/notification/sms/switch/' + id,
    method: 'post'
  });
}

/**
 * 通知详情
 * @param param
 */
export function notificationDetail(param) {
  var data = {
    detailType: param.type,
    id: param.id
  };
  return request({
    url: '/admin/platform/notification/detail',
    method: 'get',
    params: data
  });
}

/**
 * 修改通知
 * @param param
 */
export function notificationUpdate(param) {
  var data = {
    detailType: param.type,
    id: param.id,
    status: param.status,
    tempId: param.tempId
  };
  return request({
    url: '/admin/platform/notification/update',
    method: 'post',
    data: data
  });
}